import React from "react";

import { Grid } from "@material-ui/core";
import LastTwelveMonthsTotalVisits from "./LastTwelveMonthsTotalVisits";
import LatestMonthVisits from "./LatestMonthVisits";
import LatestMonthDwellTime from "./LatestMonthDwellTime";
import Map from "./Map";
import MapMeasure from "./MapMeasure";

const Footfall: React.FC = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
                <LastTwelveMonthsTotalVisits />
            </Grid>
            <Grid item xs={12} md={4}>
                <LatestMonthVisits />
            </Grid>
            <Grid item xs={12} md={4}>
                <LatestMonthDwellTime />
            </Grid>
            <Grid item xs={12}>
                <MapMeasure />
            </Grid>
            <Grid item xs={12}>
                <Map />
            </Grid>
        </Grid>
    );
};

export default Footfall;
